<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="testimonial_name"
        class="form-control-label">Name</label>
        <input
          required
          id="testimonial_name"
          v-model="item.name"
          :class="['form-control', !isValid('name') ? 'is-invalid' : 'is-valid']"
          type="text"
          placeholder="">
      <div
        v-if="!isValid('name')"
        class="invalid-feedback">{{ violations.name }}</div>
    </div>
    <div class="form-group">
      <label
        for="testimonial_created"
        class="form-control-label">Created</label>
        <!-- <input
          id="testimonial_created"
          v-model="item.created"
          :class="['form-control', !isValid('created') ? 'is-invalid' : 'is-valid']"
          type="dateTime"
          placeholder=""> -->
          <date-picker value-type="YYYY-MM-DD" :required="true" id="testimonial_created" class="w-100" :placeholder="createdDate" :default-value="item.created" v-model="item.created" type="date"></date-picker>
      <div
        v-if="!isValid('created')"
        class="invalid-feedback">{{ violations.created }}</div>
    </div>
    <div class="form-group">
      <label
        for="testimonial_message"
        class="form-control-label">Message</label>
        <textarea
          required
          id="testimonial_message"
          v-model="item.message"
          :class="['form-control', !isValid('message') ? 'is-invalid' : 'is-valid']"
          type="text"
          row="3"
          placeholder=""></textarea>
      <div
        v-if="!isValid('message')"
        class="invalid-feedback">{{ violations.message }}</div>
    </div>
    <div class="form-group">
      <label
        for="testimonial_audio"
        class="form-control-label">Audio</label>
        <select
          v-model="item.audio"
          id="testimonial_audio"
          class="form-control"
        >
          <option v-for="selectItem in audioSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  :selected="isSelected('audio', selectItem['@id'])">{{ selectItem['name'] }}
          </option>
        </select>
      <div
        v-if="!isValid('audio')"
        class="invalid-feedback">{{ violations.audio }}</div>
    </div>
    <div class="form-group">
      <label
        for="testimonial_video"
        class="form-control-label">Video</label>
        <select
          v-model="item.video"
          id="testimonial_video"
          class="form-control"
        >
          <option v-for="selectItem in videoSelectItems"
                  :key="selectItem['@id']"
                  :value="selectItem['@id']"
                  :selected="isSelected('video', selectItem['@id'])">{{ selectItem['name'] }}
          </option>
        </select>
      <div
        v-if="!isValid('video')"
        class="invalid-feedback">{{ violations.video }}</div>
    </div>
    <div class="form-group">
      <label
        for="testimonial_isValid"
        class="form-control-label">IsValid</label>                
        <div class="display d-flex align-items-center">
          <span>False</span>
          <label class="toggle mx-4 my-3">
            <input id="testimonial_isValid" v-model="item.isValid" type="checkbox" class="toggle_input" />
            <div class="toggle-control"></div>
          </label>
          <span>True</span>
        </div>          
      <div
        v-if="!isValid('isValid')"
        class="invalid-feedback">{{ violations.isValid }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">Submit</button>
  </form>
</template>

<script>
  import { find, get, isUndefined } from 'lodash';
  import { mapFields } from 'vuex-map-fields';
  import { mapActions } from 'vuex';
  import moment from 'moment';

export default {
  data() {
      return {
        createdDate: '',
      }
    },
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },

    values: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      default: () => {},
    },

    initialValues: {
      type: Object,
      default: () => {},
    }
  },

  created() {    
    if (this.item.created != null) {
      this.createdDate = moment(this.item.created).format("Y-MM-DD");  
    } else {
      // this.item.created = moment().format("Y-MM-DD");
      // this.createdDate = '';
    } 

    if (this.item.audio != null) {
      this.item.audio = this.item.audio['@id'];
    } 

    if (this.item.video != null) {
      this.item.video = this.item.video['@id'];
    } 

    if (this.item.isValid == null) {
      this.item.isValid = false;
    }
  },

  mounted() {
    this.audioGetSelectItems();
    this.videoGetSelectItems();    
  },

  computed: {
    ...mapFields('audio/list', {
      'audioSelectItems': 'selectItems',
    }),
    ...mapFields('video/list', {
      'videoSelectItems': 'selectItems',
    }),   

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    violations() {
      return this.errors || {};
    },
  },

  methods: {
    ...mapActions({
        audioGetSelectItems: 'audio/list/getSelectItems',
        videoGetSelectItems: 'video/list/getSelectItems'      
    }),

    isSelected(collection, id) {
      return find(this.item[collection], ['@id', id]) !== undefined;
    },

    isValid(key) {
      return isUndefined(get(this.violations, key));
    },
  },
};
</script>
<style lang="scss">
  .mx-input {
    border: 1px solid #28a745;
    color: #495057;
    &:hover {
      border-color: #28a745;      
    }
    &:focus {
      border-color: #28a745;
      box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
    }
  }
  .mx-icon-calendar {
    color: #28a745;
  }
  // Toggle button
  $color_checkbox_success:#4cd964;
  $color_checkbox_default:#8E8E93;
  $transition: .3s cubic-bezier(0.95, 0.05, 0.795, 0.035);
  $width: 4em;
  $height: $width/2;

  .toggle{  
    .toggle-control{
      transition: $transition;
      width: $width;
      height: $height;
      display: block;
      border: 2px solid $color_checkbox_default;
      border-radius: $height;
      background-color: rgba(black,.06);
      position: relative;
      
      &:after{
        transition: $transition;
        content: "";
        width: $width/2;
        height: $height;
        display: block;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0 1px 2px rgba(black, .4),0 3px 2px rgba(black,.4);
        position: absolute;
        top: -2px;
        left: 0;
      }
    }
    input{
      display: none;
      &:checked + .toggle-control{
        border-color: $color_checkbox_success;
        background-color: $color_checkbox_success;
        &:after{
          left: $width/2;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/testimonial/Form.vue